import { abilitiesPlugin } from '@casl/vue';
import { roles } from './userData.js';
import { AbilityBuilder, Ability } from '@casl/ability';
const consola = createLogger(__filename);
export let ability;

// Init Ability
export default ({
  Vue
}) => {
  if (!roles) {
    consola.debug('Skip Casl boot');
    return;
  }
  consola.debug('Start Casl boot');
  const {
    rules,
    can
  } = new AbilityBuilder(Ability);

  // Якщо прогрузився бут userData
  if (roles) {
    // ISSUE
    if (roles.includes('issue')) {
      can('manage', 'issue');
    }
    // Управление запросами
    if (roles.includes('issue-hud')) {
      can('read', 'issue-hud');
    }
    // добавлять задачи для ТПД
    if (roles.includes('issue-swe-task')) {
      can('read', 'issue-swe-task');
    }
    // начинать визит
    if (roles.includes('issue-start-visit')) {
      can('read', 'issue-start-visit');
    }
    // разрешение на закрытие запроса (у кого не стоит issue-complete-limit)
    if (!roles.includes('issue-complete-limit')) {
      can('read', 'issue-complete');
    }
    // разрешение на переоткрытие запроса только в текущий день (у кого не стоит issue-reopen)
    if (!roles.includes('issue-reopen-limit')) {
      can('read', 'issue-reopen');
    }
    // ограничение на назначение запроса только пользователям из своих групп (+ участники запроса)
    if (!roles.includes('issue-assign-limit')) {
      can('read', 'issue-assign-all');
    }
    // ограничение на просмотр инфо по точкам
    if (!roles.includes('issue-pos-limit')) {
      can('read', 'issue-pos');
    }

    // Заказы
    // Создание заказов
    if (roles.includes('order')) {
      can('read', 'order');
    }

    // Причина невзятия заказа
    if (roles.includes('order-status')) {
      can('read', 'order-status');
    }

    // ограничение на просмотр инфо по БЗ
    if (!roles.includes('kb-limit')) {
      can('read', 'kb');
    }

    // CALL
    if (roles.includes('call')) {
      can('read', 'call');
    }
    if (roles.includes('call-hud')) {
      can('read', 'call-hud');
    }
    if (roles.includes('dashboard-operator')) {
      can('read', 'dashboard-operator');
    }
    if (roles.includes('report-operator')) {
      can('read', 'report-operator');
    }
    if (roles.includes('report-phone')) {
      can('read', 'report-phone');
    }
    if (roles.includes('report-issue')) {
      can('read', 'report-issue');
    }
    if (roles.includes('report-da')) {
      can('read', 'report-da');
    }
    if (roles.includes('demo')) {
      can('read', 'demo');
    }
    if (roles.includes('admin')) {
      can('manage', 'all');
    }
    if (!roles.includes('chat')) {
      can('read', 'chat');
    }

    // OOS
    if (roles.includes('oos')) {
      can('read', 'oos');
    }
    if (roles.includes('oos-dashboard')) {
      can('read', 'oos-dashboard');
    }
    if (roles.includes('oos-admin')) {
      can('read', 'oos-admin');
    }
    if (!roles.includes('script')) {
      can('read', 'script');
    }
    if (roles.includes('call-download-record')) {
      can('read', 'call-download-record');
    }

    // разрешение на прослушку записи звонка
    if (!roles.includes('call-listen-limit')) {
      can('read', 'call-listen');
    }
    if (roles.includes('call-analysis')) {
      can('read', 'call-analysis');
    }

    // SMS
    // Массовая отправка SMS
    if (roles.includes('sms-bulk')) {
      can('read', 'sms-bulk');
    }

    // POS
    // отправка смс
    if (roles.includes('pos-sms')) {
      can('read', 'pos-sms');
    }

    // канал, договор и Классификация
    if (roles.includes('pos-master-data')) {
      can('read', 'pos-master-data');
    }

    // Участие в программе лояльности
    if (roles.includes('pos-loyalty')) {
      can('read', 'pos-loyalty');
    }

    // Отказ работы с TLA
    if (roles.includes('pos-tla')) {
      can('read', 'pos-tla');
    }

    // Рейтинг лояльности точки
    if (roles.includes('pos-rating')) {
      can('read', 'pos-rating');
    }

    // Мультивендор
    if (roles.includes('pos-multivendor')) {
      can('read', 'pos-multivendor');
    }

    // КОНТАКТЫ
    if (roles.includes('pos-contact')) {
      can('read', 'pos-contact');
    }

    // Логин пароль В2В
    if (roles.includes('pos-auth')) {
      can('read', 'pos-auth');
    }

    // Особенности
    if (roles.includes('pos-spec')) {
      can('read', 'pos-spec');
    }

    // Классификация
    if (roles.includes('pos-master-data')) {
      can('read', 'pos-master-data');
    }

    // территория
    if (roles.includes('pos-territory')) {
      can('read', 'pos-territory');
    }

    // редактирование Т1 по ТТ
    if (roles.includes('pos-t1')) {
      can('read', 'pos-t1');
    }

    // Инфо по продажам
    if (roles.includes('pos-sale')) {
      can('read', 'pos-sale');
    }

    // Оборудование
    if (roles.includes('pos-equipment')) {
      can('read', 'pos-equipment');
    }

    // Задолженность ТТ
    if (roles.includes('pos-debit')) {
      can('read', 'pos-debit');
    }

    // ТАРА
    if (roles.includes('pos-tara')) {
      can('read', 'pos-tara');
    }

    // Блокування ТТ
    if (roles.includes('pos-block')) {
      can('read', 'pos-block');
    }

    // комментарии
    if (roles.includes('pos-comment')) {
      can('read', 'pos-comment');
    }

    // коментар до замовлення
    if (roles.includes('pos-comment-for-order')) {
      can('read', 'pos-comment-for-order');
    }

    // Поиск ТС по карте
    if (roles.includes('map')) {
      can('read', 'map');
    }

    // адресати для інформування за замовченням
    if (roles.includes('issue-send-email')) {
      can('manage', 'issue-send-email');
    }
  }
  ability = new Ability(rules);
  Vue.use(abilitiesPlugin, ability);
  consola.debug('End Casl boot');
};